/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';


export interface FirmwareVersionCustomerDto { 
    addedDeviceFeatures?: Array<FirmwareVersionCustomerDto.AddedDeviceFeaturesEnum>;
    availableDeviceFeatures?: Array<FirmwareVersionCustomerDto.AvailableDeviceFeaturesEnum>;
    binaryChecksum?: string;
    binarySize?: number;
    firmwareClassId?: string;
    id?: string;
    officialChangelog?: string;
    releaseDate?: string;
    releaseForCustomer?: boolean;
    removedDeviceFeatures?: Array<FirmwareVersionCustomerDto.RemovedDeviceFeaturesEnum>;
    version?: Version;
}
export namespace FirmwareVersionCustomerDto {
    export const AddedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type AddedDeviceFeaturesEnum = typeof AddedDeviceFeaturesEnum[keyof typeof AddedDeviceFeaturesEnum];
    export const AvailableDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type AvailableDeviceFeaturesEnum = typeof AvailableDeviceFeaturesEnum[keyof typeof AvailableDeviceFeaturesEnum];
    export const RemovedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type RemovedDeviceFeaturesEnum = typeof RemovedDeviceFeaturesEnum[keyof typeof RemovedDeviceFeaturesEnum];
}


export type AvailableDeviceFeaturesEnum = typeof FirmwareVersionCustomerDto.AvailableDeviceFeaturesEnum[keyof typeof FirmwareVersionCustomerDto.AvailableDeviceFeaturesEnum];
